<!-- 首页菜单 -->
<template>
  <div class="menuIndex">
    <div class="task_prompt">
      <div>当前学习计划<span class="amount" @click="gotoSubmenuByType(1)">{{
          this.global.basicsUnread.length + this.global.mustLearnVideo
        }}</span>份,
      </div>
      <div @click="gotoexam()" class="amount2"><span>考核</span></div>
      <div>,法规<span class="amount" @click="gotoSubmenuByType(3)">{{ statutesUnread.length }}</span>项</div>
    </div>
    <div class="menuList">
      <div class="menuList_row" v-for="item in menuList_title" :key="item.id">
        <div class="menuList_title" :class="getPermission(item.main_limit) ? 'usableTitel' : 'notApplicable'">
          {{ item.main_menu }}
        </div>
        <div class="menuList_str">
          <p class="menuList_line"
             v-for="i in getMenuRow(item.id)"
             :key="i.id"
             @click="gotoSubmenu(i, item)"
             :class="getMenuPermission(i.menu_limit, item.main_limit) ? 'usableLine' : 'notApplicable'">
            {{ i.menu }}
          </p>
        </div>
      </div>
    </div>
    <!--     考试试卷选择-->
    <el-dialog
      title="选择试卷"
      :visible.sync="examShow"
      width="55%">
      <div>
        <el-table
          :data="examRan"
          style="width: 100%">
          <el-table-column
            type="index"
            label="序号"
            width="180">
          </el-table-column>
          <el-table-column
            prop="name"
            align="left"
            label="考卷名称">
          </el-table-column>
          <el-table-column
            prop="scores"
            align="center"
            label="分数">
          </el-table-column>
          <el-table-column
            prop="scores"
            align="center"
            label="操作">
            <template slot-scope="scope">
              <el-button type="primary" @click="startExam(scope.row)">开始考试</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as req from '@/utils/request'

export default {
  data () {
    return {
      examineVisible: false,
      menuList_title: [],
      mustLearnVideo: 0,
      // 菜单列表
      menuList: [],
      // 学习列表
      learnList: [],
      // 基础未读
      basicsUnread: [],
      // 考核未读
      assessUnread: [],
      // 法规未读
      statutesUnread: [],
      examShow: false,
      examRan: []
    }
  },
  mounted () {
    // this.global.gjl = this.getUnreadList
  },
  watch: {
    // '$route' (val, o) {
    //   if (val.path === '/index/menuIndex') {
    //     this.getLearnList()
    //   }
    // }
  },
  methods: {
    startExam (row) {
      let id = row.id
      this.$router.push({name: 'examination', params: {id: id}})
    },
    RanExam () {
      let msg = {}
      msg.id = window.$global.user_info.station_id
      let sendData = {}
      sendData.data = msg
      sendData.fn = this.RanExamFn
      sendData.vm = this
      req.Post('exam/RanExam', sendData)
    },
    RanExamFn (data) {
      if (data.err_code !== 0) {
        return
      }
      this.examRan = data.result
    },
    gotoexam () {
      if (this.global.station_id !== 29) {
        let str = ''
        let canTakeTheExam = false
        if (this.global.mustLearnVideo > 0) {
          str = '当前还有 ' + (this.global.mustLearnVideo) + ' 个视频未学习'
          canTakeTheExam = true
        }
        if (this.basicsUnread.length > 0) {
          str += '<br>当前还有 ' + this.basicsUnread.length + ' 份书本未阅读'
          canTakeTheExam = true
        }
        if (this.statutesUnread.length > 0) {
          str += '<br>当前还有 ' + this.statutesUnread.length + ' 项法规未阅读'
          canTakeTheExam = true
        }
        if (canTakeTheExam) {
          this.$alert(str, '提示', {
            confirmButtonText: '确定',
            dangerouslyUseHTMLString: true
          })
          return
        }
      }
      this.RanExam()
      this.examShow = true
    },
    // 跳转到考试
    startTest (data) {
      this.$router.push({path: '/examination', query: {data: data}})
    },
    gotoSubmenuByType (type) {
      this.global.model = parseInt(type)
      this.$router.push({path: '/index/submenu', query: {type: type}})
    },
    // 获取有效期的学习列表
    getLearnList () {
      let now = parseInt(new Date().getTime() / 1000)
      let info = this.global.user_info
      let filter = {}
      filter.job = info.station_id
      filter.begin = now
      filter.end = now
      filter.belong_ship = info.serve_ship
      filter.branch_id = info.branch_id
      filter.remove = 0
      let obj = {}
      obj.filter = filter
      let sendData = {}
      sendData.data = obj
      sendData.fn = this.getLearnListFn
      sendData.vm = this
      req.Post('ship_train/post', sendData)
    },
    // 获取三个未读列表
    getUnreadList () {
      let typeList = this.global.learnType
      this.basicsUnread = this.getUnreadByType(typeList[0].id)
      this.global.basicsUnread = this.basicsUnread
      this.assessUnread = this.getUnreadByType(typeList[1].id)
      this.statutesUnread = this.getUnreadByType(typeList[2].id)
    },
    getUnreadByType (type) {
      let user = this.global.user_info
      let learnObj = this.global.stringToJson(user.study_record)
      let learnList = this.learnList
      let list = []
      for (let i in learnList) {
        let learn = learnList[i]
        let id = learn.id
        if (learn.type !== type) {
          continue
        }
        let job = learn.job
        if (job === 0 && learn.exclude != null) {
          let exclude = learn.exclude
          // debugger
          if (exclude.indexOf(user.station_id) !== -1) { // 如果exclude 数组里边存在用户岗位 就直接跳过该书本 不添加
            continue
          }
        }
        let data = learnObj[id]
        if (data) {
          if (data.isOver) {
            continue
          }
        }
        list.push(learn)
      }
      // debugger
      // this.global.basicsUnread = list
      return list
    },
    getLearnListFn (data) {
      if (data == null || data.err_code !== 0) {
        // alert(data.err_msg)
        return
      }
      this.learnList = data.list
      this.global.learnList = data.list
      this.getUnreadList()
      console.log('获取有效的书本')
    },
    // 获取菜单
    getMenuList () {
      let sendData = {}
      sendData.data = {}
      sendData.fn = this.getMenuListFn
      sendData.vm = this
      req.Post('menu/menu_list', sendData)
    },
    getMenuListFn (data) {
      if (data.err_code !== 0) {
        alert(data.err_msg)
        return
      }
      this.menuList = data.list
    },
    // 获取菜单标题
    getMenuTitle () {
      let sendData = {}
      sendData.data = {}
      sendData.fn = this.getMenuTitleFn
      sendData.vm = this
      req.Post('main_menu/get', sendData)
    },
    // 获取用户视频播放记录
    getVideoPlayed () {
      let token = this.global.token
      let msg = {}
      msg.token = token
      let sendData = {}
      sendData.data = msg
      sendData.fn = this.getVideoPlayedFn
      sendData.vm = this
      req.Post('user/analy_token', sendData)
    },
    getVideoPlayedFn (data) {
      if (data.list == null) {
        return
      }
      let obj = data.list['played']
      this.global.videoReadList = (obj)
    },
    getMenuRow (titleId) {
      let id = '|' + titleId + '|'
      let list = this.menuList
      let row = []
      for (let i in list) {
        if (list[i].main_id.indexOf(id) > -1) {
          // eslint-disable-next-line eqeqeq
          if (list[i].menu == '发电机实船业务' && this.global.station_id != 13) {
            continue // 发电机实船业务菜单 只有电机员岗位才能出现其他岗位不显示
          }
          row.push(list[i])
        }
      }
      return row
    },
    getMenuTitleFn (data) {
      if (data.err_code !== 0) {
        alert(data.err_msg)
        return
      }
      this.menuList_title = data.list
    },
    // 根据用户部门判断权限
    getPermission (menuLimit) {
      if (menuLimit === null) {
        return true
      }
      let id = '|' + this.global.user_info.branch_id + '|'
      // 如果存在于menuLimit中代表没有权限
      let res = menuLimit.indexOf(id)
      if (res > -1) {
        return false
      }
      return true
    },
    getMenuPermission (menuLimit, mainLimit) {
      if (menuLimit === null) {
        return true
      }
      let id = '|' + this.global.user_info.branch_id + '|'
      // 如果存在于menuLimit中代表没有权限
      let res = menuLimit.indexOf(id)
      if (res > -1) {
        return false
      }
      let mainRes = mainLimit.indexOf(id)
      if (mainRes > -1) {
        return false
      }
      return true
    },
    gotoSubmenu (data, main) {
      let res = this.getMenuPermission(data.menu_limit, main.main_limit)
      if (!res) {
        return
      }
      if (main.id === 2) { // 学习视频
        this.global.model = 2
      }
      data.mainId = main.id
      this.$router.push({path: '/index/submenu', query: {data: data}})
      // this.$route.query.id
    }
  },
  // 路由进来前
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getMenuList()
      vm.getMenuTitle()
      vm.getLearnList()
      // vm.getVideoPlayed()
    })
  },
  // 路由跳出后
  beforeRouteLeave (to, from, next) {
    next()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.examineList {
  height: 500px;
  overflow-y: auto;
}

.examineRow:hover {
  background-color: rgb(224, 224, 224);
}

.examineRow {
  cursor: pointer;
  height: 50px;
  font-size: 22px;
  width: 100%;
  display: flex;
  align-items: center;
  /* justify-content: center; */
}

.menuIndex {
  width: 100%;
  height: 100%;
}

.task_prompt {
  width: 98%;
  height: 13%;
  margin: auto;
  position: relative;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 42px;
}

.menuList {
  width: 98%;
  height: 77%;
  margin: auto;
  background-color: #ffffff;
  /* padding: 15px; */
  display: flex;
}

.menuList_row {
  border-right: 1px solid #d5d5d5;
  text-align: center;
  width: 20%;
  height: 100%;
}

.menuList_title {
  height: 13%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}

.menuList_str {
  height: 87%;
}

.menuList_line {
  height: 12%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.usableTitel {
  color: #262626;
}

.usableLine {
  color: #00aaff;
}

.usableLine:hover {
  color: #002c74;
}

.notApplicable {
  color: #a6a6a6;
}

.task {
  width: 15%;
  height: 76%;
}

.amount {
  font-size: 55px;
  color: #00aaff;
  margin-left: 10px;
  margin-right: 10px;
  cursor: pointer;
}

.amount:hover {
  color: #002c74;
}

.amount2:hover {
  color: #002c74;
}

.amount2 {
  font-size: 45px;
  color: #00aaff;
}

.task_title {
  height: 31%;
  width: 50%;
  position: absolute;
  right: 5%;
  color: white;
  font-size: 18px;
  text-align: center;
  bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/menuIndex.vue